module.exports = __webpack_public_path__ + "img/indexSide-zh-hk.741e7c29.png";